package com.ervasstudio.tracoemovimento.components.custumcomponents

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Iframe

@Composable
fun YouTubeShort(videoId: String, width: CSSSizeValue<CSSUnit.px> = 315.px) {
    Iframe(
        attrs = Modifier
            .width(width)
            .aspectRatio(9, 16)
            .styleModifier { borderRadius(12.px) }
            .toAttrs {
                attr("src", "https://www.youtube.com/embed/$videoId")
                attr("frameborder", "0")
                attr(
                    "allow",
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                )
                attr("allowfullscreen", "")
            }
    )
}